// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FbtqCEamBHqU4l {
  align-items: center;
  row-gap: var(--ds-space-200, 16px);
  flex-direction: column;
  display: flex;
}

.FbtqCEamBHqU4l > h2, .FbtqCEamBHqU4l > p {
  width: 50%;
  margin: var(--ds-space-0, 0);
  text-align: center;
}

.FbtqCEamBHqU4l > h2 {
  font: var(--ds-font-heading-medium, 600 20px/28px var(--ds-font-family-heading, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif));
}

.FbtqCEamBHqU4l > p {
  font: var(--ds-font-body, normal 14px/20px -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif);
}

.FbtqCEamBHqU4l .JFz1CLZpfQskgf {
  row-gap: var(--ds-space-200, 16px);
  flex-direction: column;
  width: 75%;
  display: flex;
}

.FbtqCEamBHqU4l .yrSQOlckwgDryq {
  justify-content: flex-end;
  width: 75%;
  display: flex;
}

.gZbYF73ofUmU7e {
  row-gap: var(--ds-space-100, 8px);
  flex-direction: column;
  display: flex;
}

.qYDfq5OCe6CDpf {
  margin: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  font: var(--ds-font-body, normal 14px/20px -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif);
}

.aMI8kLj17nyB9O {
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.aMI8kLj17nyB9O label {
  color: var(--ds-text-subtle, #44546f);
  font: var(--ds-font-body, normal 14px/20px -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif);
}

.N8vzZMRXXv127D {
  align-items: center;
  column-gap: var(--ds-space-050, 4px);
  display: flex;
}

.TDZOP_bEqvhU4v {
  color: var(--ds-text-subtlest, #626f86);
  cursor: help;
  align-items: center;
  display: inline-flex;
}

.XPNHHp7Lg21U_d {
  margin: var(--ds-space-0, 0);
  color: var(--ds-text-subtlest, #626f86);
  font: var(--ds-font-body-small, normal 12px/16px -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif);
}
`, ""]);
// Exports
export var container = `FbtqCEamBHqU4l`;
export var formContainer = `JFz1CLZpfQskgf`;
export var buttonContainer = `yrSQOlckwgDryq`;
export var field = `gZbYF73ofUmU7e`;
export var fieldLabel = `qYDfq5OCe6CDpf`;
export var proactiveRow = `aMI8kLj17nyB9O`;
export var proactiveLabel = `N8vzZMRXXv127D`;
export var helpIcon = `TDZOP_bEqvhU4v`;
export var hint = `XPNHHp7Lg21U_d`;
export default ___CSS_LOADER_EXPORT___;
